// Feature flags for rollout management
// Set rollout0Enabled to false to revert all rollout0 features

export const featureFlags = {
  rollout0Enabled: true,

  rollout0: {
    phoneInHeader: true,
    emergencyBanner: false,
    seoMetaTags: true,
    trustSignals: true,
    serviceAreaInfo: true,
    compiledTailwind: true, // Use compiled Tailwind instead of CDN
    improvedContactForm: true,
    beforeAfterGallery: true,
  },

  // Submission spam gate. Set to false to restore the previous behaviour of
  // sending every submission to Google Forms and reporting every one of them
  // as an ad conversion. Kill switch: flip this if a real lead is ever refused.
  spamGateEnabled: true,
};

// Helper function to check if a rollout0 feature is enabled
export const isRollout0Feature = (feature: keyof typeof featureFlags.rollout0): boolean => {
  return featureFlags.rollout0Enabled && featureFlags.rollout0[feature];
};

// Company contact information
export const contactInfo = {
  phone: '(863) 453-4555',
  phoneRaw: '18634534555',
  email: 'info@lemayroofing.com',
  address: 'Avon Park, FL',
  serviceArea: ['Avon Park', 'Lake Placid', 'Sebring', 'Wauchula', 'Highlands County'],
  yearsInBusiness: 30,
  licenseNumber: 'CCC1234567', // Update with actual license
  insuranceCoverage: 'Fully Licensed & Insured',
};

// Trust signals
export const trustSignals = {
  yearsExperience: '30+',
  projectsCompleted: '1000+',
  certifications: ['Licensed Roofing Contractor', 'Insured', 'GAF Certified'],
  ratings: {
    google: 4.9,
    reviewCount: 150,
  }
};
